export default {
  ADD_CUSTOMER: 'ADD_CUSTOMER',
};
